import React, { Fragment } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowUp } from '@zonofi/svg-icons/arrow_up.svg';
import { ReactComponent as ArrowDown } from '@zonofi/svg-icons/arrow_down.svg';

export interface ItemData {
  label: string;
  fullMatch?: boolean;
  icon?: string;
  route?: string;
  isExpanded?: boolean;
  actionType?: string;
  sublabel?: string;
  children?: Omit<ItemData, 'children' | 'isExpanded'>[];
}

interface DrawerItemProps extends ItemData {
  onPress: (route: string, label: string, actionType?: string) => void;
  onClose: () => void;
}

export const DrawerItem: React.FC<DrawerItemProps> = ({
  label,
  onPress,
  route,
  actionType,
  icon,
  sublabel,
  children = [],
  isExpanded,
  onClose,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const path = location.pathname;
  const fullPath = location.pathname + location.search;
  const isNestedPathMatch = (baseRoute: string) =>
    path === baseRoute || path.startsWith(`${baseRoute}/`);

  return (
    <Fragment key={label}>
      <div
        className="side-drawer-list-item font-semibold"
        onClick={() => onPress(route as string, label, actionType)}
      >
        <div className="side-drawer-list-item-label">
          <img src={icon} alt={label} />
          <div>
            <span>{label}</span>
            {sublabel && (
              <div className="side-drawer-list-item-sub-label font-regular">
                {sublabel}
              </div>
            )}
          </div>
        </div>
        {children.length > 0 &&
          (isExpanded ? (
            <ArrowUp className="side-drawer-header--check" />
          ) : (
            <ArrowDown className="side-drawer-header--check" />
          ))}
      </div>

      {isExpanded && (
        <div className="side-drawer-list-child">
          {children.map(
            ({ label: childLabel, route: childRoute, fullMatch }) => {
              const isActive = fullMatch
                ? childRoute === fullPath
                : !!childRoute && isNestedPathMatch(childRoute);
              return (
                <div
                  key={childLabel}
                  className="side-drawer-list-child-item font-regular"
                  style={isActive ? { borderLeftColor: 'white' } : {}}
                  onClick={() => {
                    if (childRoute) {
                      navigate(childRoute);
                      onClose();
                    }
                  }}
                >
                  {childLabel}
                </div>
              );
            }
          )}
        </div>
      )}
    </Fragment>
  );
};
